<template>
    <b-sidebar
        v-if="isSidebarOpen"
        v-model="isSidebarOpen"
        id="sidebar-right"
        right
        backdrop
        shadow
        width="109em"
        backdrop-variant="dark"
        ref="editItem"
        no-close-on-backdrop
        no-close-on-route-change
        @change="closeSidePanelCallback()"
    >
        <template #title>
            <div>
                <strong id="sidebar-right___title__">{{ label }}</strong>
                <template v-if="!isAgent && !isClientAccount">
                    <b-button @click="itogsActivate = !itogsActivate" size="sm" class="ml-3 mb-1 mr-2" v-if="itogs.length > 0 && needItogs">
                        <span v-if="$mq != 'sm'">Итоги</span>
                        <b-icon icon="file-arrow-down" aria-hidden="true" v-if="!itogsActivate"></b-icon>
                        <b-icon icon="file-arrow-up" aria-hidden="true" v-if="itogsActivate"></b-icon>
                    </b-button>
                    <b-button @click="exportTable('financeTable', 'finance')" size="sm" class="mb-1 mr-2" v-if="items.length > 0">
                        <span v-if="$mq != 'sm'">Экспорт</span>
                        <b-icon icon="cloud-download" aria-hidden="true" v-if="!isExportData"></b-icon>
                        <i class="fas fa-spinner fa-spin" v-else></i>
                    </b-button>
                    <b-button @click="isMakeGraphPanel=!isMakeGraphPanel" size="sm" class="mb-1 mr-2" v-if="items.length > 0">
                        <span v-if="$mq != 'sm'">График</span>
                        <b-icon icon="bar-chart-line" aria-hidden="true" v-if="!isMakeGraphPanel"></b-icon>
                        <b-icon icon="bar-chart-line-fill" aria-hidden="true" v-if="isMakeGraphPanel"></b-icon>
                    </b-button>
                </template>
            </div>
        </template>
        <div class="d-block mb-4" v-if="itogs.length > 0 && itogsActivate">
            <b-card-group :deck="$mq != 'sm'">
                <b-card
                    :header="item.name"
                    header-tag="header"
                    v-for="(item, index) in itogs" :key="index"
                    :class="$mq == 'sm' ? 'mb-3' : ''"
                >
                    <b-card-text>
                        <div>
                            <div class="text-muted small">Старые клиенты:</div>
                            <div>{{ formatNumbers(item.old) }}&nbsp;р.</div>
                        </div>
                        <div>
                            <div class="text-muted small">Новые клиенты:</div>
                            <div>{{ formatNumbers(item.new) }}&nbsp;р.</div>
                        </div>
                    </b-card-text>
                </b-card>
            </b-card-group>
            <div :class="$mq == 'sm' ? 'text-center' : 'text-right'" class="font-italic text-muted mt-3">Суммы в карточках указаны без НДС</div>
        </div>
        <div class="d-block">
            <template v-if="isMakeGraphPanel">
                <EasyGraphGenerator
                    :items="items"
                    :fields="fields"
                    :allowedKeys="[
                        'company_source',
                        'order_source',
                        'close_finance_date',
                        'company_manager_to_name',
                        'order_id',
                        'finance_substatuses_line',
                        'invoice_datetime',
                        'creator.name',
                        'service.reference.name',
                        'order.company.name',
                        'invoice_type_name',
                        'company_name',
                        'company.name',
                        'realization_datetime',
                        'currency_local.name',
                        'payment_datetime'
                    ]"
                ></EasyGraphGenerator>
            </template>
            
            <div class="position-relative">
                <div
                    v-if="items.length && items.length > 0"
                    class="position-absolute text-right small text-secondary"
                    style="right: 0px; top: -22px;"
                >Записей: {{ items.length }}{{ items.length > 9999 ? "+":"" }}</div>

                <b-table
                    id="financeTable"
                    striped hover
                    :items="items"
                    :fields="fields"
                    :sticky-header="computedWindowHeight"
                    :busy="isTableBusy"
                    :sort-by="'order_id'"
                    :sort-desc="false"
                    :stacked="stacked"
                    :responsive="responsive"
                >
                    <template #cell(selected)="{ rowSelected, data }">
                        <div class="text-center">
                            <template v-if="rowSelected">
                              <span class="font-size-12 font-weight-bold">&check;</span>
                            </template>
                            <template v-else>
                              <span class="font-size-12 text-muted-deep">&check;</span>
                            </template>
                        </div>
                    </template>
                    <template #cell(index)="data">
                        <div class="text-center">{{ data.index + 1 }}</div>
                    </template>
                    <template #cell(invoice_number)="data">
                        <span class="font-weight-bold text-primary sidebar-link" @click="openFinanceSidebar(data.item.id)" title="Открыть счет">
                            {{ data.value }}
                        </span>
                    </template>
                    <template #cell(order_id)="data">
                        <span class="font-weight-bold sidebar-link text-primary" @click="openOrderSidebar(data.value, '', {tab: 'order-finance-requests'})" title="Открыть заказ">
                            #{{ data.value }}
                        </span>
                    </template>
                    <template #cell(company.name)="data">
                        <template v-if="data.item.company_id && !isClientAccount">
                            <span
                                class="sidebar-link font-weight-bold"
                                @click="openCompanySidebar(data.item.company_id)"
                                title="Открыть компанию"
                            >
                                {{ companyNameTdOutput(data.item, data.value) }}
                            </span>
                        </template>
                        <template v-else>
                            {{ companyNameTdOutput(data.item, data.value) }}
                        </template>
                    </template>
                    <template #cell(order.company.name)="data">
                        <template v-if="data.item.order && data.item.order.company_id && !isClientAccount">
                            <span
                                class="sidebar-link font-weight-bold"
                                @click="openCompanySidebar(data.item.order.company_id)"
                                title="Открыть компанию"
                            >
                                {{ companyNameTdOutput(data.item, data.value) }}
                            </span>
                        </template>
                        <template v-else>
                            {{ companyNameTdOutput(data.item, data.value) }}
                        </template>
                    </template>
                    <template #cell(order.company.to_manager.name)="data">
                        {{ companyTOManagerName(data.value) }}
                    </template>
                    <template #cell(company.to_manager.name)="data">
                        {{ companyTOManagerName(data.value) }}
                    </template>
                    <template #cell(sum)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(sum_currency)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(sum_difference)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(sum_payment)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(commission_bank)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(debt)="data">
                        <span class="font-weight-bold" :class="data.value > 0 ? 'text-danger' : 'text-success'">{{ debtCalc(data.item, data.value) }}</span>
                    </template>
                    <template #cell(final_sum_to_buyers_no_nds)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(final_sum_to_suppliers_no_nds)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(final_sum)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(final_sum_no_nds)="data">
                        <span class="font-weight-bold">{{ formatNumbers(data.value) }}</span>
                    </template>
                    <template #cell(with_nds_text)="data">
                        <template v-if="data.item.size_nds && data.item.size_nds > 0">{{ data.item.size_nds }}%</template>
                        <template v-else>{{ data.item.with_nds_text }}</template>
                    </template>
                    <template #cell(service.reference.name)="data">
                        <b-badge variant="secondary" class="special-td-badge">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(invoice_type_name)="data">
                        <b-badge variant="secondary" class="special-td-badge">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(currency_local.name)="data">
                        <b-badge variant="secondary" class="special-td-badge">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(creator.name)="data">
                        <template v-if="data.item.creator">
                            {{ data.item.creator.name }}
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(service_for_partner.name)="data">
                        <template v-if="data.item.service_for_partner">
                            {{ data.item.service_for_partner.name }}
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(zero_rate_text)="data">
                        <template v-if="data.value">
                            <b-badge variant="success" class="special-td-badge">{{ data.value }}</b-badge>
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(finance_substatuses_line)="data">
                        <template v-if="data.value">
                            <div class="small-td-table"><span class="no-wrap" v-html="data.value"></span></div>
                        </template>
                        <template v-else>
                            —
                        </template>
                    </template>
                    <template #cell(company_name)="data">
                        <template v-if="data.item.company_id && !isClientAccount">
                            <span
                                class="sidebar-link font-weight-bold"
                                @click="openCompanySidebar(data.item.company_id)"
                                title="Открыть компанию"
                            >
                                {{ data.value }}
                            </span>
                        </template>
                        <template v-else>
                            {{ data.value }}
                        </template>
                    </template>
                    <template #cell(company_manager_to_name)="data">
                        {{ companyTOManagerName(data.value) }}
                    </template>
                    <template #cell(company_portfolio_type)="data">
                        <b-badge variant="secondary" class="special-td-badge">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(company_source)="data">
                        <b-badge variant="secondary" class="special-td-badge">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(order_source)="data">
                        <b-badge variant="secondary" class="special-td-badge">{{ data.value }}</b-badge>
                    </template>
                    <template #cell(finance_ids)="data">
                        <div v-if="data.item.finance_ids && data.item.finance_ids.length > 0">
                            <b-badge
                                v-for="(item, index) in data.item.finance_ids"
                                :key="item.id"
                                variant="success"
                                class="mr-1 mb-1 cursor-pointer special-td-badge"
                                @click="openFinanceSidebar(item.id)"
                                :title="`Открыть счет: ${item.invoice_number}`"
                            >
                                {{ item.invoice_number }}
                            </b-badge>
                        </div>
                        <div class="text-center" v-else>—</div>
                    </template>
                    <template #cell(receive_datetime)="data">
                        <template v-if="!isExportData">{{ data.value | formattedDateTime }}</template>
                        <template v-else>{{ data.value }}</template>
                    </template>
                    <template #cell(processing_end_datetime)="data">
                        <template v-if="!isExportData">{{ data.value | formattedDateTime }}</template>
                        <template v-else>{{ data.value }}</template>
                    </template>
                    <template #cell(invoice_datetime)="data">
                        <template v-if="!isExportData">{{ data.value | formattedDate }}</template>
                        <template v-else>{{ data.value }}</template>
                    </template>
                    <template #cell(realization_datetime)="data">
                        <template v-if="!isExportData">{{ data.value | formattedDate }}</template>
                        <template v-else>{{ data.value }}</template>
                    </template>
                    <template #cell(payment_datetime)="data">
                        <template v-if="!isExportData">{{ data.value | formattedDate }}</template>
                        <template v-else>{{ data.value }}</template>
                    </template>
                    <template #cell(close_finance_date)="data">
                        <template v-if="!isExportData">{{ data.value | formattedDate }}</template>
                        <template v-else>{{ data.value }}</template>
                    </template>
                    <template #cell()="data">
                        <template v-if="data.field.loading">
                            <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                            <template v-else>{{ data.value }}</template>
                        </template>
                        <template v-else>
                            {{ data.value || "—" }}
                        </template>
                    </template>
                    <template v-slot:table-busy>
                        <div v-for="skeletonItem in 12" :key="skeletonItem">
                            <b-skeleton type="input" height="40px" class="mb-3"></b-skeleton>
                        </div>
                    </template>
                    <template #empty="scope">
                        <p class="my-4"><em>Таблица временно пуста. Попробуйте добавить новую запись.</em></p>
                    </template>
                    <template #emptyfiltered="scope">
                        <p class="my-4"><em>По заданному фильтру ничего не найдено</em></p>
                    </template>
                </b-table>
            </div>
        </div>
    </b-sidebar>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { API_GET_FINANCE_BY_IDS, API_GET_FINANCE_BY_IDS_GROUPED_BY_CLOSED_ORDERS } from "../../constants";
    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        excelExportHelpers
    } from '../../mixins'
    import { openFinanceSidebar } from '@/mixins/openFinanceSidebar';
    import { openOrderSidebar } from '@/mixins/openOrderSidebar';
    import { openCompanySidebar } from '@/mixins/openCompanySidebar';
    import EasyGraphGenerator from '@/components/charts/EasyGraphGenerator.vue';

    const initialFieldsForGroupesByOrders = () => ([
        {
            'key': 'order_id',
            'label': 'Номер поставки',
            'stickyColumn': true,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true,
            'tdAttr': {
                'data-t': 'n',
            }
        },
        {
            'key': 'company_name',
            'label': 'Компания',
            'stickyColumn': true,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true
        },
        {
            'key': 'company_manager_to_name',
            'label': 'Менеджер ВЭД',
            'stickyColumn': true,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true
        },
        {
            'key': 'company_portfolio_type',
            'label': 'Тип взаимоотношений',
            'stickyColumn': false,
            'sortable': true,
            'visible': true
        },
        {
            'key': 'final_sum_to_buyers_no_nds',
            'label': 'Сумма покупателям без НДС',
            'stickyColumn': true,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true,
            'tdAttr': {
                'data-t': 'n',
            }
        },
        {
            'key': 'final_sum_to_suppliers_no_nds',
            'label': 'Сумма поставщикам без НДС',
            'stickyColumn': true,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true,
            'tdAttr': {
                'data-t': 'n',
            }
        },
        {
            'key': 'final_sum_no_nds',
            'label': 'Итоговая сумма без НДС',
            'stickyColumn': true,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true,
            'tdAttr': {
                'data-t': 'n',
            }
        },
        {
            'key': 'final_sum',
            'label': 'Итоговая сумма с НДС',
            'stickyColumn': true,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true,
            'tdAttr': {
                'data-t': 'n',
            }
        },
        {
            'key': 'finance_ids',
            'label': 'Счета в расчетах',
            'stickyColumn': false,
            'sortable': false,
            'sortDirection': 'desc',
            'visible': true
        },
        {
            'key': 'close_finance_date',
            'label': 'Финальная дата закрытия финансов',
            'stickyColumn': true,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true,
            'tdAttr': {
                'data-t': 'd',
            }
        },
        {
            'key': 'company_source',
            'label': 'Источник клиента',
            'stickyColumn': false,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true
        },
        {
            'key': 'order_source',
            'label': 'Источник поставки',
            'stickyColumn': false,
            'sortable': true,
            'sortDirection': 'desc',
            'visible': true
        },
    ])
    export default {
        props: {
            openFinanceList: { type: Boolean, required: true },              // Need to open financeList
            financeList: { type: Array, required: true },                    // Open List
            needGroup: { type: Boolean, required: false, default: false },   // Need to open financeList
            cbr: { type: Object, required: false },                          // Send valutes currencies for calc operations
            periodStart: {type: String, required: false},                    // Period start for check company portfolio status
            periodEnd: {type: String, required: false},                      // Period start for check company portfolio status
            label: {                                                         // List label for sidebar
                        type: String,
                        default: 'Список счетов/компаний',
                        required: false
                   },
            to_manager_from_order: {type: Boolean, default: null},
            needItogs: { type: Boolean, required: false, default: true },   // Need itogs button
        },
        components: {
            EasyGraphGenerator
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            excelExportHelpers,
            openFinanceSidebar,
            openOrderSidebar,
            openCompanySidebar
        ],
        data() {
            return {
                isTableBusy: false,
                computedWindowHeight: '',
                fields: this.getFieldsByRole(),
                items: [],
                itogsActivate: false,
                itogs: [],
                isMakeGraphPanel: false
            }
        },
        watch: {
            financeList: {
                handler(ids) {
                    this.getDataHandler(ids)
                },
                immediate: true
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),
            
            isClientAccount() {
                return this.currentUser.role.includes('client');
            },

            isAgent() {
                return this.currentUser.role.includes("agent");
            },
            
            // Мобильная адаптация
            stacked() {
                const stackedBreakpoints = ['sm'];
                return stackedBreakpoints.includes(this.$mq);
            },
            responsive() {
                const responsiveBreakpoints = ['md', 'lg', 'xl'];
                return responsiveBreakpoints.includes(this.$mq);
            },
        },
        created() {
            window.addEventListener("resize", this.handlerHeightWindow);
        },
        destroyed() {
            window.removeEventListener("resize", this.handlerHeightWindow);
        },
        mounted() {
            this.handlerHeightWindow()
        },
        methods: {
            getFieldsByRole() {
                // Если пользователь является агентом, используем специальный набор полей
                if (this.isAgent) {
                    return [
                        {
                            'key': 'invoice_number',
                            'label': 'Номер счета',
                            'stickyColumn': true,
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true
                        },
                        {
                            'key': 'order_id',
                            'label': 'Поставка',
                            'stickyColumn': true,
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true
                        },
                        {
                            'key': 'invoice_datetime',
                            'label': 'Дата счета',
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true,
                            'formatter': 'formattedDate'
                        },
                        {
                            'key': 'realization_datetime',
                            'label': 'Дата реализации',
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true,
                            'formatter': 'formattedDate'
                        },
                        {
                            'key': 'service.reference.name',
                            'label': 'Услуга',
                            'sortable': true,
                            'sortDirection': 'desc',
                            'class': 'text-center',
                            'visible': true
                        },
                        {
                            'key': 'sum',
                            'label': 'Сумма',
                            'stickyColumn': false,
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true,
                            'tdAttr': {
                                'data-t': 'n'
                            }
                        },
                        {
                            'key': 'currency_local.name',
                            'label': 'Валюта',
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true
                        },
                        {
                            'key': 'sum_currency',
                            'label': 'Сумма в валюте',
                            'stickyColumn': false,
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true,
                            'tdAttr': {
                                'data-t': 'n'
                            }
                        },
                        {
                            'key': 'with_nds_text',
                            'label': 'с НДС',
                            'stickyColumn': false,
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true
                        },
                        {
                            'key': 'commission_bank',
                            'label': 'Комиссия банка при валютных платежах',
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true,
                            'tdAttr': {
                                'data-t': 'n'
                            }
                        },
                        {
                            'key': 'sum_payment',
                            'label': 'Оплачено',
                            'stickyColumn': false,
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true,
                            'tdAttr': {
                                'data-t': 'n'
                            }
                        },
                        {
                            'key': 'debt',
                            'label': 'Задолженность',
                            'stickyColumn': false,
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true,
                            'tdAttr': {
                                'data-t': 'n'
                            }
                        },
                        {
                            'key': 'payment_datetime',
                            'label': 'Дата финальной оплаты',
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true,
                            'formatter': 'formattedDate'
                        },
                        {
                            'key': 'invoice_type_name',
                            'label': 'Тип счета',
                            'sortable': true,
                            'sortDirection': 'desc',
                            'visible': true
                        }
                    ];
                }
                
                // Стандартный набор полей для остальных ролей
                return [
                    {
                        'key': 'invoice_number',
                        'label': 'Номер счета',
                        'stickyColumn': true,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'order_id',
                        'label': 'Номер поставки',
                        'stickyColumn': true,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'finance_substatuses_line',
                        'label': 'Предоставлены',
                        'stickyColumn': false,
                        'sortable': false,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'invoice_datetime',
                        'label': 'Дата счета',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'creator.name',
                        'label': 'Менеджер счета',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': this.getTOManagerKeyName(this.to_manager_from_order),
                        'label': 'Менеджер компании',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'service.reference.name',
                        'label': 'Услуга',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'order.company.name',
                        'label': 'Плательщик',
                        'stickyColumn': true,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'invoice_type_name',
                        'label': 'Тип счета',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'company.name',
                        'label': 'Получатель',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'realization_datetime',
                        'label': 'Дата реализации',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'service_for_partner.name',
                        'label': 'Тип услуги контрагентов',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'currency_local.name',
                        'label': 'Валюта',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'sum',
                        'label': 'Сумма',
                        'stickyColumn': false,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true,
                        'tdAttr': {
                            'data-t': 'n'
                        }
                    },
                    {
                        'key': 'sum_currency',
                        'label': 'Сумма в валюте',
                        'stickyColumn': false,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true,
                        'tdAttr': {
                            'data-t': 'n'
                        }
                    },
                    {
                        'key': 'zero_rate_text',
                        'label': 'Нулевая ставка?',
                        'stickyColumn': false,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'with_nds_text',
                        'label': 'с НДС',
                        'stickyColumn': false,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'commission_bank',
                        'label': 'Комиссия банка',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true,
                        'tdAttr': {
                            'data-t': 'n'
                        }
                    },
                    {
                        'key': 'sum_difference',
                        'label': 'Суммовая разница',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true,
                        'tdAttr': {
                            'data-t': 'n'
                        }
                    },
                    {
                        'key': 'sum_payment',
                        'label': 'Оплачено',
                        'stickyColumn': false,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true,
                        'tdAttr': {
                            'data-t': 'n'
                        }
                    },
                    {
                        'key': 'debt',
                        'label': 'Задолженность, рубли',
                        'stickyColumn': false,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true,
                        'tdAttr': {
                            'data-t': 'n'
                        }
                    },
                    {
                        'key': 'payment_datetime',
                        'label': 'Дата финальной оплаты',
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    }
                ];
            },
            getTOManagerKeyName(from_order){
                if (from_order === null){
                    return null;
                } else {
                    return from_order ? 'order.company.to_manager.name' : 'company.to_manager.name'
                }
            },
            handlerHeightWindow() {
                let deleteHeight = 115
                this.computedWindowHeight = `${window.top.innerHeight - deleteHeight}px`
            },
            getDataHandler: async function(ids) {
                this.isTableBusy = true
                this.isSidebarOpen = true

                let finalIdsList = []

                if (ids[0].finance_id) {
                    finalIdsList = ids.map((id) => {
                        return id.finance_id
                    })
                } else {
                    finalIdsList = ids
                }

                let apiUrl = API_GET_FINANCE_BY_IDS
                if (this.needGroup) {
                    apiUrl = API_GET_FINANCE_BY_IDS_GROUPED_BY_CLOSED_ORDERS
                    this.fields = initialFieldsForGroupesByOrders()
                } else {
                    // Если не группировка, используем поля в зависимости от роли
                    this.fields = this.getFieldsByRole();
                }

                await api.call('post', apiUrl, {"finance_ids": finalIdsList, "period_start": this.periodStart, "period_end": this.periodEnd})
                    .then((response) => {
                        this.isTableBusy = false
                        this.items = response.data

                        if (this.needGroup) {
                            this.itogs = this.items.itogs
                            this.items = this.items.items
                        }
                    })
            },
            closeSidePanelCallback() {
                this.closeFinanceList()
                this.isSidebarOpen = false
            },
            closeFinanceList() {
                this.$emit("closeFinanceList")
            },
            companyNameTdOutput(item, value) {
                if (item.short_order && item.short_order == 1) {
                    return item.temp_name
                }
                return value
            },
            companyTOManagerName(value) {
                return !!value ? value : 'Менеджер не задан';
            },
            debtCalc(item, value) {
                let finalDebt = value

                if (this.cbr && this.cbr.USD && item.reference_currency_id != 122) {
                    finalDebt = item.debt_new * this.cbr[item.currency_local.name]
                    finalDebt = finalDebt.toFixed(2)
                }

                return this.formatNumbers(finalDebt)
            },
        },

    }
</script>
